import React, { Component } from "react";
import { connect } from "react-redux";
import _ from "lodash";
import moment from "moment";
import { fetchEmailLogContent } from "SettingActions";
import { DISPLAY_LOCAL_DATE_FORMAT } from "Constants";
import LogContent from "./log-content";
import LocaleStrings from "Languages";
class ListItem extends Component {
  constructor(props) {
    super(props);
    this.state = { isOpen: false };
  }

  openModals = (logdata) => {
    this.props.fetchEmailLogContent(
      this.props.session,
      logdata.logid,
      (callback) => {
        this.setState({ isOpen: true });
      }
    );
  };

  closeModals = () => {
    this.setState({ isOpen: false });
  };

  render() {
    var { logdata, callfrom } = this.props;
    // console.log("logdata", logdata);
    return (
      <tr key={logdata.logid}>
        <td className="text-break" style={{ width: "20%" }}>
          {logdata.recipients}
        </td>
        <td style={{ width: "10%" }}>
          {logdata.timestamp != null ? (
            <div>
              {moment
                .unix(logdata.timestamp)
                .format(`${DISPLAY_LOCAL_DATE_FORMAT} HH:mm`)}
            </div>
          ) : (
            ""
          )}{" "}
        </td>
        {/* <td className='td3'> {_.startCase(logdata.email_status)}</td> */}
        <td style={{ width: "10%" }}>
          {logdata.log_from !== "mailgun" ? (
            <span>{_.startCase(logdata.log_from)}</span>
          ) : (
            ""
          )}
        </td>
        <td className="text-break" style={{ width: "45%" }}>
          {logdata.email_status == "delivered" ? (
            <div>Delivered Successfully</div>
          ) : logdata.email_status == "opened" ? (
            <div>Opened the email</div>
          ) : logdata.email_status != null && logdata.reason != null ? (
            <div>Failed: {logdata.reason}</div>
          ) : (
            "-"
          )}
        </td>
        <td style={{ width: "15%" }}>
          <button
            className="btn btn-custom-table-white"
            type="button"
            onClick={() => this.openModals(logdata)}>
            {callfrom == "users" ? (
              <>{LocaleStrings.view__EmailLog}</>
            ) : (
              <>{LocaleStrings.view_content_EmailLog}</>
            )}
          </button>
          {this.state.isOpen ? (
            <LogContent
              isOpen={this.state.isOpen}
              onClose={this.closeModals}
              data={this.props.logdata}
            />
          ) : (
            ""
          )}
        </td>
      </tr>
    );
  }
}
function mapStateToProps(state) {
  return {
    session: state.session,
  };
}
export default connect(mapStateToProps, { fetchEmailLogContent })(ListItem);
